import { Logo } from "../landing/Logo";
import { WaitlistForm } from "../landing/WaitlistForm";
import { scrollToId } from "../landing/Navbar";
import { Reveal } from "../landing/Reveal";

const COLUMNS = [
  {
    h: "Company",
    links: [
      { l: "About", href: "#top" },
      { l: "Careers", href: "#community" },
      { l: "Investors", href: "#investors" },
      { l: "Blog", href: "#top" },
    ],
  },
  {
    h: "Trust",
    links: [
      { l: "Privacy", href: "#top" },
      { l: "Security", href: "#enterprise" },
      { l: "Support", href: "#top" },
      { l: "Contact", href: "#claim" },
    ],
  },
  {
    h: "Products",
    links: [
      { l: "LearnNova", href: "#products" },
      { l: "CareerNova", href: "#products" },
      { l: "LoanNova", href: "#loannova" },
      { l: "Funz AI", href: "#zeno" },
    ],
  },
];

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/5 pt-24">
    <div aria-hidden="true" className="absolute -top-32 left-1/2 h-72 w-[720px] -translate-x-1/2 rounded-full bg-[#635BFF]/10 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col items-start gap-8">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          Get Started
        </p>
        <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          The campus economy is live. Claim your seat.
        </h2>
        <WaitlistForm compact />
      </Reveal>

      <div className="mt-20 grid grid-cols-2 gap-10 border-t border-white/5 pt-12 sm:grid-cols-4">
        <div className="col-span-2 sm:col-span-1">
          <div className="flex items-center gap-2.5">
            <Logo className="h-8 w-8" />
            <span className="font-display text-lg font-extrabold tracking-[0.18em] text-white">
              FUNZ
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-slate-500">
            The Gen Z Economic Operating System. Learn · Earn · Build · Belong.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.h}>
            <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              {col.h}
            </p>
            <ul className="mt-4 space-y-3">
              {col.links.map((link) => (
                <li key={link.l}>
                  <a
                    href={link.href}
                    onClick={scrollToId(link.href)}
                    data-testid={`site-footer-${link.l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-slate-400 transition-colors hover:text-[#00D26A]"
                  >
                    {link.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pointer-events-none mt-16 select-none overflow-hidden" aria-hidden="true">
        <p className="text-stroke whitespace-nowrap text-center font-display text-[19vw] font-black leading-[0.85] tracking-tight">
          FUNZ
        </p>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-white/5 py-8 sm:flex-row">
        <p className="font-jbmono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 FUNZ · All rights reserved
        </p>
        <p className="font-jbmono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          Learn · Earn · Build · Belong
        </p>
      </div>
    </div>
  </footer>
);
